export default "__VITE_ASSET__DhfmL8au__"